export default "__VITE_ASSET__DXHVKa8t__"